export default "__VITE_ASSET__BSyDym71__"